module.exports = __webpack_public_path__ + "static/media/product_ac_pic_online.a56d718b.png";